import { render, staticRenderFns } from "./MailIcon.vue?vue&type=template&id=10a5ed20&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a5ed20",
  null
  
)

export default component.exports